import App from './App.css'
import React from 'react';
import MyData from './MyData';



function Card(prop) {
  return (
    <>
      <div class="card">
        <img class="card-img-top" src={prop.imglink} alt="Title" />
        <div class="card-body">
          <h4 class="card-title">{prop.title}</h4>
          <p class="card-text">{prop.netflix}</p>
          <div className='button'>
            <a href={prop.link} target='_blank'>
              <button type="button" id='ok' class="btn btn-primary">Watch Now</button></a>
          </div>
        </div>
      </div>

      
    </>
  );
}

export default Card;
